export const SDK_VERSION = '7.43.0';
